import _taggedTemplateLiteral from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3;
import { jsx as e, jsxs as i } from "react/jsx-runtime";
import t from "styled-components";
import { calculateRem as n } from "@vds-core/utilities";
import { ColorTokens as o } from "@vds-tokens/color";
import { LayoutTokens as r } from "@vds-tokens/layout";
import { TypographyTokens as a } from "@vds-tokens/typography";
import l from "./PaginationLink.js";
var s = e("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.6 21.6",
    children: e("path", {
      d: "M19.8,11.7h-15l7.1,7.1L10.7,20l-9.3-9.2l9.3-9.2l1.3,1.3L4.8,9.9h15L19.8,11.7z"
    })
  }),
  p = e("svg", {
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.6 21.6",
    children: e("path", {
      d: "M20.26723,10.80317,10.94378,20.044,9.6764,18.7643l7.12223-7.05674H1.8014v-1.8H16.808L9.68256,2.84378l1.26738-1.278Z"
    })
  }),
  c = "44px",
  d = 12,
  u = a.fontweight.bold.value,
  m = o.elements.primary.onlight.value,
  h = o.elements.primary.ondark.value,
  g = r.space["2X"].value,
  f = {
    previous: {
      ariaLabel: "Go to previous page.",
      icon: s,
      text: "Previous",
      pageNumber: function pageNumber(e) {
        return Math.max(1, e - 1);
      },
      visibility: function visibility(e) {
        return 1 === e ? "hidden" : "visible";
      }
    },
    next: {
      ariaLabel: "Go to next page.",
      icon: p,
      text: "Next",
      pageNumber: function pageNumber(e, i) {
        return Math.min(i, e + 1);
      },
      visibility: function visibility(e, i) {
        return e === i ? "hidden" : "visible";
      }
    }
  },
  v = t.span.withConfig({
    displayName: "StepControlSpan",
    componentId: "VDS__sc-29nbz6-0"
  })(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  svg {\n    margin-top: -1px;\n  }\n"]))),
  x = t.div.withConfig({
    displayName: "IconWrapper",
    componentId: "VDS__sc-29nbz6-1"
  })(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  ", "\n"])), function (_ref) {
    var e = _ref.direction;
    return "previous" === e ? "padding-right: ".concat(n(g)) : "padding-left: ".concat(n(g));
  }),
  y = t.div.withConfig({
    displayName: "IconSVGWrapper",
    componentId: "VDS__sc-29nbz6-2"
  })(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  height: ", ";\n  width: ", ";\n  min-height: ", ";\n  min-width: ", ";\n  outline: none;\n  pointer-events: none;\n  &:active,\n  &:focus {\n    outline: none;\n  }\n  svg {\n    height: ", ";\n    width: ", ";\n    path {\n      fill: ", ";\n    }\n  }\n"])), n(d), n(d), n(d), n(d), n(d), n(d), function (_ref2) {
    var e = _ref2.$iconColor;
    return e;
  }),
  b = function b(t) {
    var o = t.baseUrl,
      r = t.selectedPage,
      a = t.onClick,
      s = t.cta,
      p = t.position,
      d = t.level,
      g = t.dataTrack,
      b = t.surface,
      w = t.direction,
      $ = t.total,
      k = {
        display: "flex",
        justifyContent: "previous" === w ? "flex-end" : "flex-start",
        alignItems: "center",
        fontWeight: u,
        height: n(c),
        minWidth: n(c),
        visibility: f[w].visibility(r, $)
      },
      L = f[w].pageNumber(r, $);
    return e(l, {
      "aria-label": f[w].ariaLabel,
      baseUrl: o,
      selectedPage: r,
      pageNumber: L,
      linkStyles: k,
      onClick: function onClick() {
        a(L);
      },
      cta: s,
      position: p,
      level: d,
      dataTrack: g,
      surface: b,
      children: i(v, {
        children: ["next" === w && f[w].text, e(x, {
          direction: w,
          children: e(y, {
            $iconColor: "dark" === b ? h : m,
            "aria-label": "pagination-".concat("previous" === w ? "left" : "right", "-arrow icon"),
            children: f[w].icon
          })
        }), "previous" === w && f[w].text]
      })
    });
  };
b.defaultProps = {
  surface: "light"
};
export { b as default };